/* React */
import React from "react";

/* React Redux */
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setDefaultState,
  upsertCustomCohort,
  setError,
} from "src/redux/features/custom-cohorts/customCohortsSlice";

/* Ionic */
import { add, save } from "ionicons/icons";

/* Components */
import PrimaryFabButton from "src/components/shared/buttons/primary-fab-button/PrimaryFabButton";

/* Interfaces */
import {
  BasicProps,
  LogicalProps,
} from "src/shared/interfaces/custom-cohorts/CustomCohorts";

interface OptionsProps {
  segments?: BasicProps | LogicalProps;
}

const Options: React.FC<OptionsProps> = ({ segments }) => {
  const dispatch = useDispatch();

  const customCohortsState = useSelector(
    (state: RootState) => state.customCohorts
  );

  const { customCohort } = customCohortsState;
  const { name, status } = customCohort;

  const handleUpsertCohort = () => {
    try {
      dispatch(
        upsertCustomCohort({
          ...customCohort,
          name: name,
          data: segments,
        })
      );
    } catch (error: unknown) {
      const clientError = error as Error;

      dispatch(
        setError({
          message: clientError.message,
        })
      );
    }
  };

  return (
    <PrimaryFabButton
      ariaLabel={"Create or save cohort"}
      icon={!status ? save : add}
      disabled={!segments}
      onClick={() => {
        if (!status) {
          handleUpsertCohort();
        } else {
          dispatch(setDefaultState());
        }
      }}
      scssProps={{
        position: "fixed",
        margin: "0 12px auto auto",
        right: 0,
        background: "var(--ion-gradient-primary)",
        bottom: 12,
        boxShadow: "var(--ion-box-shadow)",
        icon: {
          height: "21px",
          width: "21px",
        },
      }}
    />
  );
};

export default Options;
